<div class="navbar">
  <img
    class="convex-logo"
    src="assets/Convex-logo.svg"
    alt="convex logo"
    (click)="home()"
    (keypress)="home()"
    tabindex="0"
  />
  <img
    class="arup-logo"
    src="assets/0_landing_page/Arup logo.svg"
    alt="Arup logo"
    (click)="arup()"
    (keypress)="arup()"
    tabindex="0"
  />
</div>
